import { ButtonHTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import { ThemeColor } from 'styled-components';
import { IconListType } from '../Icon';

export enum AIButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type AIButtonTypeProperties = {
  background: ThemeColor | [ThemeColor, ThemeColor];
  hover: ThemeColor | [ThemeColor, ThemeColor];
  content: ThemeColor;
};

export type AIButtonTypeStyles = Record<AIButtonType, AIButtonTypeProperties>;

export type AIButtonStyles = {
  backgroundColor: string;
  hoverColor: string;
  contentColor: string;
  padding: string;
  height: string;
  fontSize?: string;

  margin?: string;
  pointerEvents?: string;
  width?: string;
};

export enum AIButtonSize {
  LARGE = 'large',
  SMALL = 'small',
  XSMALL = 'xsmall',
}

export interface AIButtonSizeProperties {
  padding: string;
  height: string;
  fontSize?: string;
  iconSize: string;
}

export type AIButtonSizeStyles = Record<AIButtonSize, AIButtonSizeProperties>;

export interface AIButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconName?: IconListType;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  /**
   * When using the isLoading prop, make sure to set a fixed width with the `width` prop.
   * This will prevent the button from resizing when the loading spinner is shown.
   */
  isLoading?: boolean;
  btnType?: AIButtonType;
  btnSize?: AIButtonSize;
  margin?: string;
  width?: string;
  children?: ReactNode;
}
